export enum ViewSlider {
  collapsed = 'collapsed',
  normal = 'normal',
  expanded = 'expanded'
}